var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFbIcon = function SvgFbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.207 0A2.207 2.207 0 000 2.207v35.586C0 39.013.988 40 2.207 40h19.461V25h-5v-5h5v-3.333c0-5.165 3.725-8.334 8.334-8.334 2.208 0 3.613-.073 4.167 0l-.834 5h-3.333c-2.5 0-3.334 1.584-3.334 3.334V20h7.122l-1.288 5h-5.834v15h11.126a2.206 2.206 0 002.209-2.207V2.207A2.206 2.206 0 0037.795 0H2.206z",
    fill: "#1AA35C"
  })));
};
export default SvgFbIcon;